import type { ActivityView } from "../api/client";

/** Human phrasing for an activity event. */
export function describe(a: ActivityView): string {
  const d = a.data ?? {};
  switch (a.type) {
    case "created":
      return "created this card";
    case "moved":
      return (
        `moved this card from “${d.from ?? "?"}” to “${d.to ?? "?"}”` +
        (d.toBoard ? ` on board “${d.toBoard}”` : "")
      );
    case "renamed":
      return `renamed this card to “${d.to ?? "?"}”`;
    case "described":
      return typeof d.from === "number" && d.from === 0
        ? "added the description"
        : "edited the description";
    case "checklist_renamed":
      return `renamed checklist “${d.from ?? "?"}” to “${d.to ?? "?"}”`;
    case "checklist_item_edited":
      return `edited checklist item “${d.from ?? "?"}” → “${d.to ?? "?"}”`;
    case "completed":
      return "marked this card complete";
    case "uncompleted":
      return "marked this card incomplete";
    case "due_set":
      return "set the due date";
    case "due_cleared":
      return "cleared the due date";
    case "label_added":
      return `added label “${d.label ?? "?"}”`;
    case "label_removed":
      return `removed label “${d.label ?? "?"}”`;
    case "assignee_added":
      return `assigned ${d.user ?? "someone"}`;
    case "assignee_removed":
      return `unassigned ${d.user ?? "someone"}`;
    case "attachment_added":
      return `attached “${d.filename ?? "a file"}”`;
    case "attachment_removed":
      return `removed attachment “${d.filename ?? "a file"}”`;
    case "archived":
      return "archived this card";
    case "unarchived":
      return "restored this card from the archive";
    case "field_set":
      return d.value == null
        ? `cleared ${d.field ?? "a field"}`
        : `set ${d.field ?? "a field"} to “${d.value}”`;
    default:
      return a.type;
  }
}
